module.exports = __webpack_public_path__ + "img/Wizard.519e0895.png";